import { ADD_ORGANIZATION,ADD_ORGANIZATION_SUCCESS,ADD_ORGANIZATION_FAILED,
    GET_ORGANIZATION_DETAIL,GET_ORGANIZATION_DETAIL_SUCCESS,GET_ORGANIZATION_DETAIL_FAILED,
UPDATE_ORGANIZATION_DETAIL,UPDATE_ORGANIZATION_DETAIL_FAILED,UPDATE_ORGANIZATION_DETAIL_SUCCESS,
ORGANIZATION_DETAIL_GET_IP_LOCATION,ORGANIZATION_DETAIL_GET_IP_LOCATION_FAILED,ORGANIZATION_DETAIL_GET_IP_LOCATION_SUCCESSFULL,
ORGANIZATION_DETAIL_GET_STATE,ORGANIZATION_DETAIL_GET_STATE_FAILED,ORGANIZATION_DETAIL_GET_STATE_SUCCESSFULL,
ORGANIZATION_DETAIL_GET_COUNTRY,ORGANIZATION_DETAIL_GET_COUNTRY_FAILED,ORGANIZATION_DETAIL_GET_COUNTRY_SUCCESSFULL,
ORGANIZATION_DETAIL_GET_LIST,ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL,ORGANIZATION_DETAIL_GET_LIST_FAILED,
ORGANIZATION_DETAIL_DELETE,ORGANIZATION_DETAIL_DELETE_SUCCESSFULL,ORGANIZATION_DETAIL_DELETE_FAILED} from "../Organization/actionTypes"
// view jobs
export const addOrganizationDetail = organizationDetail => {
    return {
        type: ADD_ORGANIZATION,
        payload: { organizationDetail },
    }
}
export const addOrganizationDetailSuccess = organizationSuccess => {
    return {
        type: ADD_ORGANIZATION_SUCCESS,
        payload: { organizationSuccess },
    }
}
export const addOrganizationDetailFailed = organizationError => {
    return {
        type: ADD_ORGANIZATION_FAILED,
        payload: { organizationError },
    }
}

export const getOrganizationDetail = organizationDetail => {
    return {
        type: GET_ORGANIZATION_DETAIL,
        payload: { organizationDetail },
    }
}
export const getOrganizationDetailSuccess = organizationDetailSuccess => {
    return {
        type: GET_ORGANIZATION_DETAIL_SUCCESS,
        payload: { organizationDetailSuccess },
    }
}
export const getOrganizationDetailFailed = organizationError => {
    return {
        type: GET_ORGANIZATION_DETAIL_FAILED,
        payload: { organizationError },
    }
}

export const updateOrganizationDetail = updateOrganizationDetail => {
    return {
        type: UPDATE_ORGANIZATION_DETAIL,
        payload: { updateOrganizationDetail },
    }
}
export const updateOrganizationDetailSuccess = updateDetail => {
    return {
        type: UPDATE_ORGANIZATION_DETAIL_SUCCESS,
        payload: { updateDetail },
    }
}
export const updateOrganizationDetailFailed = organizationError => {
    return {
        type: UPDATE_ORGANIZATION_DETAIL_FAILED,
        payload: { organizationError },
    }
}

//GET COUNTRY
export const organizationDetailGetCountry = (country) => {
    return {
      type: ORGANIZATION_DETAIL_GET_COUNTRY,
      payload: {country},
    }
  }
  export const organizationDetailSetCountrySuccess = (country) => {
    return {
      type: ORGANIZATION_DETAIL_GET_COUNTRY_SUCCESSFULL,
      payload: country,
    }
  }
  export const organizationDetailSetCountryError = (country) => {
    return {
      type: ORGANIZATION_DETAIL_GET_COUNTRY_FAILED,
      payload: country,
    }
  }
  //GET STATE FUNCTIONS
  export const organizationDetailGetState = (states) => {
    return {
      type: ORGANIZATION_DETAIL_GET_STATE,
      payload: {states},
    }
  }
  export const organizationDetailSetStateSuccess = (states) => {
    return {
      type: ORGANIZATION_DETAIL_GET_STATE_SUCCESSFULL,
    payload: states,
    }
  }
  export const organizationDetailSetStateError = (states) => {
    return {
      type: ORGANIZATION_DETAIL_GET_STATE_FAILED,
      payload: states,
    }
  }
  //GET COUNTRY AND STATE ON IP BASED FUNCTIONS
  export const organizationDetailGetIpBasedLocation = (iplocation) => {
    return {
      type: ORGANIZATION_DETAIL_GET_IP_LOCATION,
      payload: {iplocation},
    }
  }
  export const organizationDetailGetIpBasedLocationSuccess = (iplocation) => {
    return {
      type: ORGANIZATION_DETAIL_GET_IP_LOCATION_SUCCESSFULL,
    payload: iplocation,
    }
  }
  export const organizationDetailGetIpBasedLocationError = (iplocation) => {
    return {
      type: ORGANIZATION_DETAIL_GET_IP_LOCATION_FAILED,
      payload: iplocation,
    }
  }

  //get organization list
  export const getOrganizationList = (organizationDetail) => {
    return {
      type: ORGANIZATION_DETAIL_GET_LIST,
      payload: {organizationDetail},
    }
  }
  export const getOrganizationListSuccess = (organizationDetail) => {
    return {
      type: ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL,
      payload: {organizationDetail},
    }
  }
  export const getOrganizationListError = (organizationDetail) => {
    return {
      type: ORGANIZATION_DETAIL_GET_LIST_FAILED,
      payload: {organizationDetail},
    }
  }
//get organization list
export const deleteOrganization = (organizationDetail) => {
  return {
    type: ORGANIZATION_DETAIL_DELETE,
    payload: {organizationDetail},
  }
}
export const deleteOrganizationSuccess = (organizationDetail) => {
  return {
    type: ORGANIZATION_DETAIL_DELETE_SUCCESSFULL,
    payload: {organizationDetail},
  }
}
export const deleteOrganizationError = (organizationDetail) => {
  return {
    type: ORGANIZATION_DETAIL_DELETE_FAILED,
    payload: {organizationDetail},
  }
}

